import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import { TextField, inputClasses, outlinedInputClasses } from '@mui/material'

const classes = {
  border: 'border',
}
const StyledTextField = styled(TextField)(({ theme }) => ({
  [`&.${classes.border}`]: {
    margin: `${theme.spacing(-0.5)} 0`,
  },
  [`& .${inputClasses.root}`]: {
    '&::before, &::after': {
      border: 'none',
    },
    '&:hover:not(.Mui-disabled):before': {
      border: 'none',
    },
  },
  [`& .${outlinedInputClasses.input}`]: {
    padding: 0,
  },
  [`&.${classes.border} .${outlinedInputClasses.input}`]: {
    padding: theme.spacing(0.5),
  },
  [`&:not(.${classes.border}) .${outlinedInputClasses.notchedOutline}`]: {
    border: 'none',
  },
}))

export default function InlineTextField({
  border,
  fontSize,
  inputProps,
  id,
  ...others
}) {
  return (
    <StyledTextField
      variant="outlined"
      margin="none"
      className={border ? classes.border : undefined}
      {...others}
      inputProps={{
        ...inputProps,
        'data-testid': `edit-price-${id}`,
        sx: { fontSize: fontSize, ...inputProps?.sx },
      }}
    />
  )
}

InlineTextField.propTypes = {
  border: T.bool,
  others: T.object,
  fontSize: T.any,
  inputProps: T.object,
}
